import { Component } from "react";
import "./App.css";
import ScrollArrow from "./components/backToTop";
import WhatsAppButton from "./components/whatsappButton";
import ContactDialog from "./components/ContactDialog";
import HeroSection from "./components/heroSection/heroSection";
import Footer from "./views/footer/footer";
import Header from "./views/header/header";
import Section1 from "./views/section1/section1";
import Section2 from "./views/section2/section2";
import Section3 from "./views/section3/section3";
import Section4 from "./views/section4/section4";
import Section5 from "./views/section5/section5";
import Section7 from "./views/section7/section7";
import SectionCases from "./views/sectionCases/sectionCases";
import SectionDepoimentos from "./views/sectionDepoimentos/sectionDepoimentos";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { dialogOpen: false };
  }

  openDialog() { this.setState({ dialogOpen: true }); }
  closeDialog() { this.setState({ dialogOpen: false }); }

  render() {
    return (
      <div>
        <Header handleClickOpen={() => this.openDialog()} />
        <ScrollArrow />
        <WhatsAppButton />

        <section className="m-to-header">
          <HeroSection handleDialogOpen={() => this.openDialog()} />
        </section>

        <section id="section1-role">
          <Section1 />
        </section>

        <section id="section2-role">
          <Section2 />
        </section>

        <section id="section3-role">
          <Section3 />
        </section>

        <section id="section4-role">
          <Section4 />
        </section>

        <section id="cases-role">
          <SectionCases />
        </section>

        <section id="depoimentos-role">
          <SectionDepoimentos />
        </section>

        <section id="section5-role">
          <Section5 />
        </section>

        <section id="section7-role">
          <Section7 handleDialogOpen={() => this.openDialog()} />
        </section>

        <section>
          <Footer handleDialogOpen={() => this.openDialog()} />
        </section>

        <ContactDialog open={this.state.dialogOpen} handleClose={() => this.closeDialog()} />
      </div>
    );
  }
}

export default App;
